import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import WithRender from "@/Pages/Admin/Modules/Settings/Email/Views/email-settings.html";
import ValidationError from "@/Pages/Admin/Modules/Common/Controllers/ValidationError";
import { flashService } from "@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService";
import { trekService } from "@/Pages/Admin/Modules/ManagePackage/Services/Trekservice";
import { common } from "@/Pages/Admin/Modules/Common/Services/Common";


@WithRender
@Component({})
export default class EmailSettings extends Vue {
  protected ui: any = {};
  protected Email: any = {};
  protected Disable: any = {};
  protected errors: any = {};
  protected errorsMessage: any = {};
  protected isError: boolean = false;
  protected ShowReadonly: boolean = false;
  protected RequestList: any = [];
  protected ApprovedTypeList: any = [];
  protected SearchBy: any = {};
  protected CC: any = [];
  protected BCC: any = [];
  protected allSelected: boolean = false;
  protected EncryptionList: any = [
    {  id: "tls", name: "TLS" },
    {  id: "tls", name: "SSL" }
  ];
  constructor() {
    super();
    this.ui.IsLoading = false;
    this.ui.PostLoading = false;
    this.ui.EmailPostLoading = false;
    this.Disable.AddEmail = false;
    this.Email.FromName = '';
    this.Email.FromEmail = '';
    this.Email.Port = '';
    this.Email.MailDriver = '';
    this.Email.HostName = '';
    this.Email.Encryption = '';
    this.Email.UserName = '';
    this.Email.Password = '';
    this.Email.Cc = [];
    this.Email.Bcc = [];
  }
  public mounted() {
    this.getAccountRequest();
  }
  public getAccountRequest() {
    // console.log("HELLO !!! from email");
    this.ui.IsLoading = true;
    let data = {

    };
    trekService
      .retrieveSettings(data)
      .then((res: any) => {
        // this.UnitList = res.data.data;
        console.log("Services :", res.data.data);
        res.data.data.filter((item: any) => {
          // segment.IsActive = false;
          if (item.setting_key === 'mail_driver') {
            this.Email.MailDriver = item.setting_value;
          }
          if (item.setting_key === 'host') {
            this.Email.HostName = item.setting_value;
          }
          if (item.setting_key === 'encryption') {
            this.EncryptionList.forEach((data: any) => {
              if (item.setting_value === data.id) {
                this.Email.Encryption = data;
              }
            });
          }
          if (item.setting_key === 'port') {
            this.Email.Port = item.setting_value;
          }
          if (item.setting_key === 'from_email') {
            this.Email.FromEmail = item.setting_value;
          }
          if (item.setting_key === 'from_name') {
            this.Email.FromName = item.setting_value;
          }
          if (item.setting_key === 'username') {
            this.Email.UserName = item.setting_value;
          }
          if (item.setting_key === 'cc') {
            this.Email.Cc = item.setting_value;
          }
          if (item.setting_key === 'bcc') {
            this.Email.Bcc = item.setting_value;
          }
        });
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.errorsMessage).then((res: any) => {
          this.isError = true;
          this.errorsMessage = res;
        });
      })
      .finally(() => {
        this.ui.IsLoading = false;
      });
  }
  // Adding Email Settings
  public async addEmailSettings() {
    this.ui.EmailPostLoading = true;
    this.Disable.AddEmail = true;
    let data = {
        mail_driver: this.Email.MailDriver,
        host: this.Email.HostName,
        encryption: this.Email.Encryption.id,
        port: this.Email.Port,
        username: this.Email.UserName,
        password: this.Email.Password,
        from_name: this.Email.FromName,
        from_email: this.Email.FromEmail,
        cc: this.Email.Cc,
        bcc: this.Email.Bcc ,
    };
    console.log(data);
    trekService
      .addSettings(data)
      .then((res: any) => {
        console.log(res.data.data);
        this.Disable.AddEmail = false;
        this.ShowReadonly = false;
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.errorsMessage).then((res: any) => {
          this.isError = true;
          this.errorsMessage = res;
        });
      })
      .finally(() => {
        this.ui.EmailPostLoading = false;
      });
  }
  //Edit Setting
  public EditEmailSettings() {
      this.ShowReadonly = true;
  }
  //Edit Setting
  public cancelEditEmailSettings() {
      this.ShowReadonly = false;
  }
  public addBccEmail() {
      console.log("BCC Email ID added");
      this.Email.Bcc.push({ email: '', name: ''});
  }
  public addCcEmail(item: any, cc_index: any) {
      console.log("CC Email ID added selected", item);
      console.log("CC Email ID added index", cc_index);
      this.Email.Cc.push({ email: '', name: ''});
  }
}
